import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import Link from 'next/link'
import { IPost } from 'src/types/hygraph'
import { formatTimestampMonthDayYear } from 'src/utils'
import { getPostTopic } from 'src/utils/hygraph'

type IProps = {
  morePosts: IPost[]
}

function MoreBlogs({ morePosts }: IProps) {
  const { t } = useTranslation('blog')

  return (
    <aside className="w-full lg:sticky lg:top-32 lg:w-[300px]">
      <p className="font-display text-[11px] tracking-[0.22em] text-blue-500 uppercase md:text-xs">
        {t('MORE.EYEBROW')}
      </p>
      <h3 className="mt-3 font-display text-[20px] leading-tight font-medium text-ink-700 md:text-[22px]">
        {t('MORE.TITLE')}
      </h3>

      <ul className="mt-6 border-t border-ink-100/15">
        {morePosts.map((post) => {
          const { basePath, topic } = getPostTopic(post)
          return (
            <li key={post.slug} className="border-b border-ink-100/15">
              <Link
                href={`${basePath}/${post.slug}`}
                className="group flex items-start gap-4 py-5 transition-colors"
              >
                {post.coverImage?.url && (
                  <div className="relative size-16 shrink-0 overflow-hidden bg-cream-300">
                    <Image
                      src={post.coverImage.url}
                      alt={post.coverImageAlt ?? ''}
                      fill
                      className="object-cover transition-transform duration-500 ease-out group-hover:scale-[1.04]"
                      sizes="64px"
                      quality={75}
                    />
                  </div>
                )}
                <div className="min-w-0 flex-1">
                  {topic?.label && (
                    <p className="font-display text-[10px] tracking-[0.2em] text-blue-500 uppercase">
                      {topic.label}
                    </p>
                  )}
                  <p className="mt-1.5 line-clamp-2 text-[14px] leading-snug text-ink-700 transition-colors group-hover:text-blue-500">
                    {post.title}
                  </p>
                  {post.createdAt && (
                    <time
                      dateTime={post.createdAt}
                      className="mt-1.5 block text-[11px] tracking-[0.04em] text-ink-200"
                    >
                      {formatTimestampMonthDayYear(post.createdAt)}
                    </time>
                  )}
                </div>
              </Link>
            </li>
          )
        })}
      </ul>
    </aside>
  )
}

export default MoreBlogs
